import { reduxKey } from './constants';
export var ModalType;
(function (ModalType) {
    ModalType["COLLECTION_MODAL"] = "COLLECTION_MODAL";
    ModalType["STATUS_UPDATE"] = "STATUS_UPDATE";
    ModalType["JOURNAL"] = "JOURNAL";
    ModalType["LITERATURE"] = "LITERATURE";
    ModalType["COMMISSION"] = "COMMISSION";
    ModalType["CONFIRMATION"] = "CONFIRMATION";
    ModalType["POLL_EDIT"] = "POLL_EDIT";
    ModalType["GIVE_BADGE"] = "GIVE_BADGE";
    ModalType["GIVE_POINTS"] = "GIVE_POINTS";
    ModalType["DONATE_POINTS"] = "DONATE_POINTS";
    ModalType["MY_GROUPS"] = "MY_GROUPS";
    ModalType["SISU_SOCIAL"] = "SISU_SOCIAL";
    ModalType["SISU_WELCOME"] = "SISU_WELCOME";
    ModalType["COMMENT_THREAD"] = "COMMENT_THREAD";
    ModalType["VERIFICATION"] = "VERIFICATION";
    ModalType["VERIFICATION_SUCCESSFUL"] = "VERIFICATION_SUCCESSFUL";
    ModalType["DEVIATION_BACKGROUND_PICKER"] = "DEVIATION_BACKGROUND_PICKER";
    ModalType["USER_BLOCK"] = "USER_BLOCK";
    ModalType["REPORT_DEVIATION"] = "REPORT_DEVIATION";
    ModalType["MOBILE_COLLECTION_PANEL"] = "MOBILE_COLLECTION_PANEL";
    ModalType["MOBILE_GROUPS_PANEL"] = "MOBILE_GROUPS_PANEL";
    ModalType["MOBILE_DEVIATION_SHARE"] = "MOBILE_DEVIATION_SHARE";
    ModalType["DEVIATION_GROUP_LIST"] = "DEVIATION_GROUP_LIST";
    ModalType["DEVIATION_PCP"] = "DEVIATION_PCP";
    ModalType["ORDER_COMMISSION"] = "ORDER_COMMISSION";
})(ModalType || (ModalType = {}));
//# sourceMappingURL=types.js.map